module.exports = __webpack_public_path__ + "img/f-ko.8bdf55b3.png";